import { createReducer } from 'typesafe-actions';

import { TAgentCardAction, ICardAgentState, agentCardActionTypes } from '@/features/cards/store/types/agent-card.types';

const initialState: ICardAgentState = {
  paginateCards: {
    elements: [],
    pagination: {
      totalPages: 0,
      currentPage: 0,
    },
  },
  isLoadingRestrictions: false,
  isLoading: false,
};

export const agentCardReducer = createReducer<ICardAgentState, TAgentCardAction>(initialState)
  .handleType(agentCardActionTypes.SEARCH_AGENT_CARDS, (state) => ({
    ...state,
    error: undefined,
    isLoading: true,
  }))

  .handleType(agentCardActionTypes.SEARCH_AGENT_CARDS_SUCCESS, (state, action) => ({
    ...state,
    paginateCards: { elements: action.cards, pagination: action.pagination },
    isLoading: false,
    error: undefined,
  }))

  .handleType(agentCardActionTypes.SEARCH_AGENT_CARDS_FAIL, (state, action) => ({
    ...state,
    error: action.error,
    isLoading: false,
  }));
